
function appointment(appointment_id){        
    return process.env.VUE_APP_URL + "/my-appointments/"+appointment_id
  }
  
  function appointmentCall(appointment_id){        
    return process.env.VUE_APP_URL + "/appointment-call/"+appointment_id
  }
  
  function medicalRecord(record_id){        
    return process.env.VUE_APP_URL + "/my-medical-records/"+record_id
  }
  

export {appointment,appointmentCall,medicalRecord};